import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { Controller, useFormContext } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { useEffect } from 'react';

function FormText({
  name,
  label,
  sublabel,
  required,
  disabled,
  transform,
  autofocus = false,
  ...other
}) {
  const { control, getValues, setValue, resetField, clearErrors } =
    useFormContext();

  const inputRef = useRef();

  useEffect(() => {
    if (autofocus) {
      inputRef.current.focus();
    }
  }, [inputRef, autofocus]);
  return (
    <Box component="div">
      <Controller
        control={control}
        name={name}
        render={({
          field: { onChange, onBlur, value },
          fieldState: { error },
        }) => (
          <>
            <TextField
              inputRef={inputRef}
              required={required}
              label={label}
              disabled={disabled}
              helperText={error ? error.message : sublabel}
              name={name}
              id={name}
              onChange={
                transform
                  ? (e) =>
                    onChange(
                      transform(
                        e,
                        getValues(),
                        setValue,
                        resetField,
                        clearErrors,
                      ),
                    )
                  : onChange
              }
              value={value || ''}
              onBlur={onBlur}
              error={!!error}
              fullWidth
              {...other}
            />
          </>
        )}
      />
    </Box>
  );
}

FormText.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  sublabel: PropTypes.string,
  transform: PropTypes.func,
};

FormText.defaultProps = {
  label: '',
  sublabel: '',
  required: false,
  disabled: false,
  transform: null,
};

export default FormText;
